import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import smaLogo from '../../assets/images/logos/ca-logo-white.png';
import smaColoredLogo from '../../assets/images/logos/ca-logo-color-256.png';
import { useDispatch, useSelector } from 'react-redux';
import MenuOpenRoundedIcon from '@material-ui/icons/MenuOpenRounded';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import { setSidebarToggle } from 'reducers/ThemeOptions';
import { useMediaQuery } from '@material-ui/core';
import { HEADER_HEIGHT } from 'config/appConfig';

const HeaderLogo = () => {
  const dispatch = useDispatch();
  const sidebarToggle = useSelector(state => state.ThemeOptions.sidebarToggle);
  const isMdDown = useMediaQuery(theme => theme.breakpoints.down('md'));

  const toggleSidebar = () => {
    dispatch(setSidebarToggle(!sidebarToggle));
  };

  return (
    <Box minWidth="185px" height={HEADER_HEIGHT} display="flex" justifyContent="space-between" alignItems="center">
      <Link to="/">
        <img
          alt="CA"
          src={isMdDown && !sidebarToggle ? smaColoredLogo : smaLogo}
          width="90px"
          style={{ marginLeft: '20px' }}
        />
      </Link>
      <IconButton color="inherit" onClick={toggleSidebar} size="medium" title="Toogle Sidebar">
        {sidebarToggle ? <MenuRoundedIcon /> : <MenuOpenRoundedIcon />}
      </IconButton>
    </Box>
  );
};

export default memo(HeaderLogo);
